import { Typography } from '@mui/material';

const UnOrderedList = (title, contents) => {
  return (
    <Typography component="div">
      {title && <p>{title}</p>}
      <ul>
        {contents.map((d) => (
          <li dangerouslySetInnerHTML={{ __html: d }}></li>
        ))}
      </ul>
    </Typography>
  );
};
const OrderedNumberList = (title, contents) => {
  return (
    <Typography component="div">
      <p>{title}</p>
      <ol>
        {contents.map((d) => (
          <li dangerouslySetInnerHTML={{ __html: d }}></li>
        ))}
      </ol>
    </Typography>
  );
};
export { UnOrderedList, OrderedNumberList };
